module.exports = __webpack_public_path__ + "img/overheads-repair-and-maintenatce.19f6b983.svg";